import { useAuth } from "src/hooks/useAuth";
import { useSegment } from "./useSegment";
import { useMemo } from "react";
import { getSearchStrategy } from "src/strategies/search.strategy";
import { locale } from "src/config/app-config";

export function useSearchProvider(): [
  ReturnType<typeof getSearchStrategy> | null,
  boolean
] {
  const { user } = useAuth();
  const { user: segmentUser } = useSegment();

  const userId = user?.member_id || segmentUser?.anonymousId?.() || undefined;

  const searchProvider = useMemo(() => {
    return typeof window !== "undefined"
      ? getSearchStrategy("constructor", { locale, userId, env: "browser" })
      : null;
  }, [userId, locale]);

  return [searchProvider, !!searchProvider];
}
